<template>
  <div class="display-services-customers">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
              <b-dropdown v-if="hasSelectedServiceItems" right no-caret variant="link" class="list-view-icon-btn list-view-icon-btn--primary" toggle-class="list-view-icon-btn list-view-icon-btn--primary" v-b-tooltip.hover.bottom title="Acciones sobre servicios seleccionados">
                <template #button-content><AppIcon name="settings" /></template>
                <b-dropdown-header>Acciones para {{ selectedServiceItems.length }} servicio{{ selectedServiceItems.length == 1 ? '' : 's' }} seleccionado{{ selectedServiceItems.length == 1 ? '' : 's' }}</b-dropdown-header>
                <b-dropdown-item v-if="moduleSalesActive" @click="generateInvoiceSelected()"><AppIcon name="receipt_long" class="mr-1" /> Facturar servicios</b-dropdown-item>
                <b-dropdown-divider v-if="moduleSalesActive" />
                <b-dropdown-item @click="generateTextNotificationEmailSelected()"><AppIcon name="mail" class="mr-1" /> Notificación por email</b-dropdown-item>
                <b-dropdown-item @click="generateTextNotificationWhatsappSelected()"><AppIcon name="chat" class="mr-1" /> Notificación por WhatsApp</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 300px;"><label class="filter-label">Clientes</label><v-select :options="arr.filter.customers" v-model="filter.customers" placeholder="Todos" :multiple="true" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="width: 300px;"><label class="filter-label">Servicios</label><v-select :options="arr.filter.services" v-model="filter.services" placeholder="Todos" :multiple="true" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="width: 160px;"><label class="filter-label">Estado</label><v-select :options="arr.filter.status" v-model="filter.status" placeholder="Activos" :multiple="true" :select-on-tab="true" /></div>
            <b-button variant="outline-dark" size="sm" @click="filterServicesCustomersDetails()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-tabs class="mt-2 display-services-customers__tabs" active-nav-item-class="font-weight-bold text-uppercase text-dark">
        <b-tab active @click="history.active = false">
          <template #title><AppIcon name="design_services" class="mr-1" /> Servicios</template>
          <b-card no-body class="mt-2">
                <div v-if="hasSelectedServiceItems" class="display-services-customers__selection-bar">
                  <span><AppIcon name="check2-square" class="mr-1" />{{ selectedServiceItems.length }} servicio{{ selectedServiceItems.length == 1 ? '' : 's' }} seleccionado{{ selectedServiceItems.length == 1 ? '' : 's' }} para {{ selectedServiceCustomerName }}</span>
                  <div><b-button size="sm" variant="link" class="list-view-link" @click="toggleSelectAllServiceItems">{{ allEligibleServiceItemsSelected ? 'Borrar selección visible' : 'Seleccionar visibles' }}</b-button><b-button size="sm" variant="link" class="list-view-link ml-2" @click="clearServiceSelection">Borrar selección</b-button></div>
                </div>
                <b-table class="mb-0 app-table table-displat-services-custom"
                        responsive
                        :hover="true"
                        sticky-header="60vh"
                        :stacked="isMobileViewport ? 'md' : false"
                        :fixed="false"
                        :current-page="1"
                        :per-page="0"
                        :busy="table.isBusy"                       
                        :items="table.items"
                        :fields="table.fields"
                        :tbody-tr-class="rowClass"
                        @row-clicked="openDetail"
                        v-if="table.items.length || table.isBusy"
                        foot>  

                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"                    
                        :key="field.key"
                        :style="{ width: field.width }"
                      >
                    </template> 

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(select_multi)="data">
                      <div v-if="isServiceSelectionEligible(data.item)" class="display-services-customers__selection-check" :class="{ 'display-services-customers__selection-check--selected': isServiceItemSelected(data.item) }" @click.stop="toggleServiceSelection(data.item)" v-b-tooltip.hover :title="isServiceItemSelected(data.item) ? 'Quitar de la selección' : 'Seleccionar servicio'">
                        <AppIcon :name="isServiceItemSelected(data.item) ? 'check2-square' : 'square'" font-scale="1.4" />
                      </div>
                    </template>

                    <template v-slot:cell(customers)="data">                  
                      <div v-if="data.item.service_customer.customer_id">             
                        <b-avatar :src="data.item.service_customer.customer.image"
                                  v-if="data.item.service_customer.customer.image">
                        </b-avatar>
                        <b-avatar v-else
                                  :text="avatarFromName(data.item.service_customer.customer.name).text"
                                  :style="avatarFromName(data.item.service_customer.customer.name).style">
                        </b-avatar>     
                        &nbsp;<b>{{data.item.service_customer.customer.name}}</b>      
                        <b-icon icon="circle-fill" v-if="!data.item.service_customer.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
                      </div>
                    </template>                

                    <template v-slot:cell(renewal)="data">                                                                        
                      <div v-if="data.item.service.mode=='days' || data.item.service.mode=='months' || data.item.service.mode=='years'">
                        <div class="display-services-customers__renewal" :class="data.item.service.automatic_renewal ? 'display-services-customers__renewal--automatic' : 'display-services-customers__renewal--manual'">
                          <AppIcon :name="data.item.service.automatic_renewal ? 'autorenew' : 'event_repeat'" />
                          <div><strong>{{ data.item.service.automatic_renewal ? 'Automática' : 'Manual' }}</strong><small>Cada {{ data.item.service.renewal }} {{ getModeName(data.item.service.mode).toLowerCase() }}</small></div>
                        </div>
                      </div>
                      <span v-else class="text-muted">—</span>
                    </template>

                    <template v-slot:cell(services)="data">     
                      <div v-if="data.item.service" class="display-services-customers__service">
                        <strong>{{data.item.service.name}}</strong>
                        <span>{{data.item.service_customer.name}}</span>
                        <div class="display-services-customers__service-icons">
                          <b-button v-if="data.item.observations" variant="link" size="sm" :id="'popover-observations-' + data.item.id" v-b-tooltip.hover title="Abrir observaciones" aria-label="Abrir observaciones"><AppIcon name="notes" /></b-button>
                          <b-popover v-if="data.item.observations" :target="'popover-observations-' + data.item.id" variant="default" triggers="click blur"><div v-html="previewPopoverObservations(data.item)"></div></b-popover>
                          <span v-if="data.item.full_sale" v-b-tooltip.hover :title="data.item.full_sale" class="display-services-customers__service-icon"><AppIcon name="receipt_long" /></span>
                        </div>
                      </div>          
                    </template>        

                    <template v-slot:cell(observations)="data">                      
                      <span v-if="data.item.observations">                                                    
                        <b-button variant="link" size="sm" :id="'popover-observations-' + data.item.id" class="popover-observations" aria-label="Abrir observaciones">
                          <AppIcon name="notes" />
                        </b-button>
                        <b-popover :target="'popover-observations-' + data.item.id" variant="default" triggers="click blur">
                          <div v-html="previewPopoverObservations(data.item)"></div>
                        </b-popover>                                                    
                      </span>                          
                    </template>

                    <template v-slot:cell(date_init)="data">  
                      <div class="display-services-customers__contract" :class="{ 'display-services-customers__contract--without-end': !data.item.date_end }">
                        <span class="display-services-customers__contract-start"><small>Inicio</small>{{moment(data.item.date_init).format('DD/MM/YYYY')}}</span>
                        <span v-if="data.item.date_end" class="display-services-customers__contract-end"><small>Fin</small>{{moment(data.item.date_end).format('DD/MM/YYYY')}}</span>
                        <span v-if="data.item.price_list" class="display-services-customers__contract-list"><small>Lista</small>{{data.item.price_list.reference}}</span>
                        <span v-if="data.item.service.mode=='hours'" class="display-services-customers__contract-quantity"><small>Cantidad</small>{{data.item.quantity}} {{data.item.service.mode}}</span>
                      </div>
                    </template>                                                      

                    <template v-slot:cell(price)="data">   
                      <div class="display-services-customers__amounts">
                        <span><small>Importe actual</small><strong>{{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.price_list ? data.item.price_list.currency.code : 'ARS'}).format(getTotalService(data.item))}}</strong></span>
                        <span><small>Importe a renovar</small><strong>{{Intl.NumberFormat('es-AR',{style:'currency',currency:getRenewalCurrency(data.item)}).format(getTotalRenewalService(data.item))}}</strong></span>
                      </div>                       
                    </template>  

                    <template v-slot:cell(date_renewal)="data">  
                      <div v-if="data.item.canceled" class="display-services-customers__due-ended">
                        <AppIcon name="event_busy" />
                        <div><strong>Finalizado</strong><small>{{ data.item.date_end ? 'Finalizó el ' + moment(data.item.date_end).format('DD/MM/YYYY') : 'Servicio cancelado' }}</small></div>
                        <b-button v-if="data.item.reasons_canceled" variant="link" size="sm" class="display-services-customers__due-ended-info" v-b-tooltip.hover :title="data.item.reasons_canceled"><AppIcon name="info" /></b-button>
                      </div>

                      <div v-if="!data.item.canceled" class="display-services-customers__due">
                        <div v-if="daysForRenewal(data.item)<1">
                          <div class="crud-services-vto-danger">
                            <strong>{{moment(data.item.date_renewal).format('DD/MM/YYYY')}}</strong>
                            <small>Vencido hace {{daysVtoRenewal(data.item)}} día/s</small>
                          </div>
                          
                          <span :id="'popover-notification-' + data.item.id" v-if="data.item.date_notification" style="cursor:pointer;">
                            <b>[AVISADO]</b>
                          </span>
                          <b-popover :target="'popover-notification-' + data.item.id" variant="default" triggers="hover" class="popover-notifications">                            
                            <div v-html="previewPopoverNotification(data.item)"></div>
                          </b-popover>                                
                        </div>
                        <div v-else>
                          <div v-if="data.item.date_renewal">
                            <div :class="[daysForRenewal(data.item)<5 ? 'crud-services-vto-warning' : 'crud-services-vto-success']">
                              <strong>{{moment(data.item.date_renewal).format('DD/MM/YYYY')}}</strong>
                              <small>Faltan {{daysForRenewal(data.item)}} día/s</small>
                            </div>
                          
                            <span :id="'popover-notification-' + data.item.id" v-if="data.item.date_notification" style="cursor:pointer;">
                              <b>[AVISADO]</b>
                            </span>
                            <b-popover :target="'popover-notification-' + data.item.id" variant="default" triggers="hover" class="popover-notifications">                            
                              <div v-html="previewPopoverNotification(data.item)"></div>
                            </b-popover>                   
                          </div>          
                        </div>
                        
                        <div v-if="data.item.project_id">
                          <b-link @click="goProject(data.item)"> 
                            <b>
                              <b-icon icon="list-task"></b-icon> Ver Proyecto
                            </b>
                          </b-link>
                        </div>
                      </div>
                    </template>  

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right no-caret
                                  size="sm"
                                  variant="link"
                                  boundary="window"
                                  :toggle-class="isMobileViewport ? 'display-services-customers-action-toggle' : 'app-table-action-toggle'"
                                  :class="{ 'pull-right': !isMobileViewport }"
                                  @show="setConfigTableDisplayServicesShow"
                                  @hide="setConfigTableDisplayServicesHide">
                        <template #button-content><AppIcon name="more_vert" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
                        
                        <b-dropdown-header v-if="showChangeService(data.item) || showRenewal(data.item) || (moduleSalesActive && showInvoiceService(data.item))">
                          Operaciones
                        </b-dropdown-header>              
                        <b-dropdown-item v-if="showRenewal(data.item)" @click="openRenewal(data.item)">
                          <AppIcon name="autorenew" class="mr-1" /> Renovar servicio
                        </b-dropdown-item>                                                                     
                        <b-dropdown-item v-if="showChangeService(data.item)" @click="openChangeService(data.item)">
                          <AppIcon name="swap_horiz" class="mr-1" /> Cambiar servicio
                        </b-dropdown-item>                                         
                        <b-dropdown-item v-if="moduleSalesActive && showInvoiceService(data.item)" @click="generateInvoice(data.item)" >
                          <AppIcon name="receipt_long" class="mr-1" /> Facturar servicio
                        </b-dropdown-item>      
                        
                        <b-dropdown-header>
                          Notificaciones
                        </b-dropdown-header>                            
                        <b-dropdown-item @click="generateTextNotificationEmail(data.item)" >
                          <AppIcon name="mail" class="mr-1" /> Notificación por email
                        </b-dropdown-item>                                                  
                        <b-dropdown-item @click="generateTextNotificationWhatsapp(data.item)" >
                          <AppIcon name="chat" class="mr-1" /> Notificación por WhatsApp
                        </b-dropdown-item>                                                  

                        <b-dropdown-header>Información</b-dropdown-header>                        
                        <b-dropdown-item @click="openPricesServices(data.item)">
                          <AppIcon name="payments" class="mr-1" /> Precios
                        </b-dropdown-item>                                                      
                        <b-dropdown-item @click="openActivity(data.item)">
                          <AppIcon name="history" class="mr-1" /> Ver actividad
                        </b-dropdown-item>                     
                        <b-dropdown-item @click="openObservations(data.item)">
                          <AppIcon name="notes" class="mr-1" /> Observaciones
                        </b-dropdown-item>                                             

                        <b-dropdown-header>Cancelaciones</b-dropdown-header>
                        <b-dropdown-item @click="openCancel(data.item)" v-if="showCanceled(data.item)">
                          <AppIcon name="cancel" class="mr-1 text-danger" /> Cancelar servicio
                        </b-dropdown-item>   
                        <b-dropdown-item @click="restoreServoceCancel(data.item)" v-else>
                          <AppIcon name="restore" class="mr-1" /> Restaurar servicio
                        </b-dropdown-item> 
                      </b-dropdown>
                    </template>   

                </b-table>
                <EmptyState v-else icon="design_services" title="No se encontraron servicios" />
                <div class="app-table-footer display-services-customers__totals" v-if="table.items.length">
                  <span class="display-services-customers__totals-label">Totales de página</span>
                  <span><small>Actual</small><strong v-html="getTotal"></strong></span>
                  <span><small>Renovación</small><strong v-html="getTotalRenewal"></strong></span>
                </div>
          </b-card>

        </b-tab>
        <b-tab @click="loadServicesCustomersActivitys()">
          <template #title><AppIcon name="history" class="mr-1" /> Historial</template>
          <DynamicSummary
            v-if="history.active"
            storage-key="dynamic_summary_services_history"
            :dimensions="history.dimensions"
            :default-groups="history.defaultGroups"
            :load-report="loadHistoryReport"
            @error="showHistoryError"
          />
        </b-tab>
      </b-tabs>

      <b-card body-class="py-2" class="mt-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)"><AppIcon name="back" class="mr-1" /> Volver</b-button>
          <nav v-if="!history.active"><b-pagination class="mb-0" size="sm" pills :total-rows="table.total" :per-page="table.perPage" :value="table.currentPage" @input="page => filterServicesCustomersDetails(page, false)" /></nav>
        </div>
      </b-card>

      <b-sidebar v-model="detailDrawer" right shadow backdrop title="Detalle del servicio" width="420px" @hidden="hideDetail">
        <div v-if="itemSelected" class="list-view-drawer display-services-customers-drawer">
          <div class="list-view-drawer__header display-services-customers-drawer__header">
            <b-avatar v-if="detailCustomer && detailCustomer.image" :src="detailCustomer.image" class="display-services-customers-drawer__avatar" />
            <b-avatar v-else-if="detailCustomer" :text="avatarFromName(detailCustomer.name).text" :style="avatarFromName(detailCustomer.name).style" class="display-services-customers-drawer__avatar" />
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code">{{ detailCustomer ? detailCustomer.name : '—' }}</span>
              <div class="list-view-drawer__meta">{{ itemSelected.service ? itemSelected.service.name : 'Servicio' }}<span v-if="itemSelected.service_customer && itemSelected.service_customer.name"> · {{ itemSelected.service_customer.name }}</span></div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm" variant="outline-secondary" :disabled="!canGoPrevServiceDetail" v-b-tooltip.hover title="Servicio anterior" @click="goPrevServiceDetail"><AppIcon name="chevron-up" label="Servicio anterior" /></b-button>
              <b-button size="sm" variant="outline-secondary" :disabled="!canGoNextServiceDetail" v-b-tooltip.hover title="Servicio siguiente" @click="goNextServiceDetail"><AppIcon name="chevron-down" label="Servicio siguiente" /></b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats">
            <div class="list-view-drawer__stat"><span class="list-view-drawer__stat-label">Inicio</span><span class="list-view-drawer__stat-value">{{ formatServiceDate(itemSelected.date_init) }}</span></div>
            <div class="list-view-drawer__stat"><span class="list-view-drawer__stat-label">Estado</span><span class="list-view-drawer__stat-value" :class="itemSelected.canceled ? 'text-danger' : 'text-success'">{{ itemSelected.canceled ? 'Finalizado' : 'Activo' }}</span></div>
            <div class="list-view-drawer__stat"><span class="list-view-drawer__stat-label">Lista</span><span class="list-view-drawer__stat-value">{{ itemSelected.price_list ? itemSelected.price_list.reference : '—' }}</span></div>
          </div>

          <section class="display-services-customers-drawer__section">
            <div class="list-view-drawer__section-title"><AppIcon name="design_services" /> Servicio contratado</div>
            <div class="display-services-customers-drawer__service-card">
              <div><span>Modalidad</span><strong>{{ getServiceModeDescription(itemSelected) }}</strong></div>
              <div v-if="itemSelected.service && itemSelected.service.mode == 'hours'"><span>Cantidad</span><strong>{{ itemSelected.quantity || 0 }} horas</strong></div>
              <div><span>Importe actual</span><strong class="display-services-customers-drawer__amount">{{ formatServiceAmount(getTotalService(itemSelected), getRenewalCurrency(itemSelected)) }}</strong></div>
              <div><span>Importe a renovar</span><strong class="display-services-customers-drawer__amount">{{ formatServiceAmount(getTotalRenewalService(itemSelected), getRenewalCurrency(itemSelected)) }}</strong></div>
            </div>
          </section>

          <section class="display-services-customers-drawer__section">
            <div class="list-view-drawer__section-title"><AppIcon name="event" /> Próxima renovación</div>
            <div class="display-services-customers-drawer__renewal-card" :class="itemSelected.canceled ? 'display-services-customers-drawer__renewal-card--ended' : ''">
              <strong>{{ itemSelected.canceled ? 'Servicio finalizado' : (itemSelected.date_renewal ? formatServiceDate(itemSelected.date_renewal) : 'Sin vencimiento') }}</strong>
              <small v-if="!itemSelected.canceled && itemSelected.date_renewal" :class="renewalStatusClass(itemSelected)">{{ renewalStatusLabel(itemSelected) }}</small>
              <small v-else-if="itemSelected.canceled && itemSelected.date_end">Finalizó el {{ formatServiceDate(itemSelected.date_end) }}</small>
            </div>
          </section>

          <section v-if="itemSelected.observations" class="display-services-customers-drawer__section">
            <div class="list-view-drawer__section-title"><AppIcon name="notes" /> Observaciones</div>
            <div class="display-services-customers-drawer__observations" v-html="itemSelected.observations"></div>
          </section>

          <div class="display-services-customers-drawer__actions">
            <div v-if="showChangeService(itemSelected) || showRenewal(itemSelected) || (moduleSalesActive && showInvoiceService(itemSelected))" class="display-services-customers-drawer__action-group">
              <span>Operaciones</span>
              <div>
                <b-button v-if="showRenewal(itemSelected)" size="sm" variant="outline-secondary" @click="openRenewal(itemSelected)"><AppIcon name="autorenew" class="mr-1" /> Renovar servicio</b-button>
                <b-button v-if="showChangeService(itemSelected)" size="sm" variant="outline-secondary" @click="openChangeService(itemSelected)"><AppIcon name="swap_horiz" class="mr-1" /> Cambiar servicio</b-button>
                <b-button v-if="moduleSalesActive && showInvoiceService(itemSelected)" size="sm" variant="outline-secondary" @click="generateInvoice(itemSelected)"><AppIcon name="receipt_long" class="mr-1" /> Facturar servicio</b-button>
              </div>
            </div>
            <div class="display-services-customers-drawer__action-group">
              <span>Notificaciones</span>
              <div>
                <b-button size="sm" variant="outline-secondary" @click="generateTextNotificationEmail(itemSelected)"><AppIcon name="mail" class="mr-1" /> Notificación por email</b-button>
                <b-button size="sm" variant="outline-secondary" @click="generateTextNotificationWhatsapp(itemSelected)"><AppIcon name="chat" class="mr-1" /> Notificación por WhatsApp</b-button>
              </div>
            </div>
            <div class="display-services-customers-drawer__action-group">
              <span>Información</span>
              <div>
                <b-button size="sm" variant="outline-secondary" @click="openPricesServices(itemSelected)"><AppIcon name="payments" class="mr-1" /> Precios</b-button>
                <b-button size="sm" variant="outline-secondary" @click="openActivity(itemSelected)"><AppIcon name="history" class="mr-1" /> Ver actividad</b-button>
                <b-button size="sm" variant="outline-secondary" @click="openObservations(itemSelected)"><AppIcon name="notes" class="mr-1" /> Observaciones</b-button>
              </div>
            </div>
            <div class="display-services-customers-drawer__action-group">
              <span>Cancelaciones</span>
              <div>
                <b-button v-if="showCanceled(itemSelected)" size="sm" variant="outline-danger" @click="openCancel(itemSelected)"><AppIcon name="cancel" class="mr-1" /> Cancelar servicio</b-button>
                <b-button v-else size="sm" variant="outline-secondary" @click="restoreServoceCancel(itemSelected)"><AppIcon name="restore" class="mr-1" /> Restaurar servicio</b-button>
              </div>
            </div>
          </div>
        </div>
      </b-sidebar>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD RENOVACION -->
      <b-modal v-model="modal.renewal.active"
              size="md"
              :key="modal.renewal._id"
              :id="modal.renewal._id">                  
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="autorenew" /></span><h5 class="app-modal-header__title">{{ modal.renewal.title }}</h5></div></template>

        <b-row class="display-services-customers__modal-context">
          <b-col lg="6">            
            <div v-if="crud.renewal.service">
              <b>{{this.crud.renewal.service.name}}</b>
              <br>
              {{this.crud.renewal.name}}
            </div>
          </b-col>          
          <b-col lg="6">            
            <div v-if="crud.renewal.customer">
              <div v-if="crud.renewal.customer.id">             
                <b-avatar :src="crud.renewal.customer.image"
                          v-if="crud.renewal.customer.image">
                </b-avatar>
                <b-avatar v-else
                          :text="avatarFromName(crud.renewal.customer.name).text"
                          :style="avatarFromName(crud.renewal.customer.name).style">
                </b-avatar>     
                &nbsp;<b>{{crud.renewal.customer.name}}</b>      
                <b-icon icon="circle-fill" v-if="!crud.renewal.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col lg="6">
            <b-form-group label="Fecha Renovación">                
              <b-form-datepicker size="sm" v-model="crud.renewal.date_renewal" placeholder="Fecha" local="es" disabled></b-form-datepicker>                      
            </b-form-group>            
          </b-col>      
          <b-col lg="6">
            <b-form-group label="Próxima Renovación">                
              <b-form-datepicker size="sm" v-model="crud.renewal.date_next_renewal" placeholder="Fecha" local="es"></b-form-datepicker>                      
            </b-form-group>            
          </b-col>                    
        </b-row>

        <b-row class="mt-3">
          <b-col md="6">
            <legend class="display-services-customer-form-renewal-period-legend">
              Período de Renovación
            </legend>
            <span>CADA <u>{{this.crud.renewal.period}}</u></span>
          </b-col>
          <b-col md="6">
            <b-form-group label="Importe">
              <b-input-group :prepend="crud.renewal.currency">
                <app-number-input v-model="crud.renewal.price"
                                  placeholder="Ingresar el precio" />
              </b-input-group>
            </b-form-group>            
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.renewal.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveRenewal()">Aceptar</b-button>          
        </div>
      </b-modal>

      <!-- CRUD ACTIVIDAD -->
      <b-modal v-model="modal.activity.active"
              size="lg">
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="history" /></span><h5 class="app-modal-header__title">{{ modal.activity.title }}</h5></div></template>

        <b-row class="display-services-customers__modal-context">
          <b-col lg="6">            
            <div v-if="arr.servicesCustomersActivitys.service">
              <b>{{this.arr.servicesCustomersActivitys.service.name}}</b>
              <br>
              {{this.arr.servicesCustomersActivitys.name}}
            </div>
          </b-col>          
          <b-col lg="6">            
            <div v-if="arr.servicesCustomersActivitys.customer">
              <div v-if="arr.servicesCustomersActivitys.customer.id">             
                <b-avatar :src="arr.servicesCustomersActivitys.customer.image"
                          v-if="arr.servicesCustomersActivitys.customer.image">
                </b-avatar>
                <b-avatar v-else
                          :text="avatarFromName(arr.servicesCustomersActivitys.customer.name).text"
                          :style="avatarFromName(arr.servicesCustomersActivitys.customer.name).style">
                </b-avatar>     
                &nbsp;<b>{{arr.servicesCustomersActivitys.customer.name}}</b>      
                <b-icon icon="circle-fill" v-if="!arr.servicesCustomersActivitys.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-table class="mt-2 mb-0 app-table app-table--compact display-services-customer-table-activity"
              responsive
              :hover="true"
              :fixed="false"                              
              :items="tableActivity.items"
              :fields="tableActivity.fields"
              v-if="tableActivity.items.length">

                <template v-slot:cell(services)="data">  
                  <div v-if="data.item.service">
                    {{data.item.service.name}}
                  </div>
                </template>  

                <template v-slot:cell(date_init)="data">  
                  {{moment(data.item.date_init).format('DD/MM/YYYY')}}
                </template>  

                <template v-slot:cell(date_end)="data">  
                  <div v-if="data.item.date_end">
                    {{moment(data.item.date_end).format('DD/MM/YYYY')}}
                  </div>
                </template>  

                <template v-slot:cell(price)="data">   
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.currency}).format(data.item.price)}}
                </template>

                <template v-slot:cell(sale_id)="data">                     
                  <div v-if="data.item.sale_id" v-b-tooltip.hover :title="data.item.sale.type_voucher.name + ' ' + data.item.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + data.item.sale.number.toString().padStart(8,'0')">
                    <AppIcon name="receipt_long" />
                  </div>                       
                </template>

                <template v-slot:cell(f_action)="data">                                       
                  <b-dropdown right no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              toggle-class="app-table-action-toggle"
                              class="pull-right"
                              v-if="!arr.servicesCustomersActivitys.canceled">                    
                    <template #button-content><AppIcon name="more_vert" /></template>
                    <b-dropdown-item @click="removeActivity(data.item)">
                      <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

            </b-table>
            <EmptyState v-else icon="history" title="No se encontraron movimientos" />
          </b-col>          
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.activity.active=false">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CRUD CANCEL -->
      <b-modal v-model="modal.cancel.active"
              size="md">
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="cancel" /></span><h5 class="app-modal-header__title">{{ modal.cancel.title }}</h5></div></template>

        <b-row>
          <b-col lg="12">
            <b-form-group label="Fecha Finalización">                
              <b-form-datepicker size="sm" v-model="crud.cancel.date_end" placeholder="Fecha" local="es"></b-form-datepicker>                      
            </b-form-group>            
          </b-col>
          <b-col lg="12">
            <b-form-group label="Motivos de Cancelación">
              <app-textarea                
                v-model="crud.cancel.reasons_canceled"
                rows="3"
                max-rows="6"
              ></app-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.cancel.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveCancel()">Aceptar</b-button>          
        </div>
      </b-modal>

      <!-- CRUD OBSERVATIONS -->
      <b-modal v-model="modal.observations.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close         
              size="xl"
              :key="modal.observations._id"
              :id="modal.observations._id">                  
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="notes" /></span><h5 class="app-modal-header__title">{{ modal.observations.title }}</h5></div></template>

        <div class="display-services-customers__modal-context">
          <b-row>
            <b-col lg="6">
              <div v-if="crud.observations.service">
                <b>{{this.crud.observations.service.name}}</b><br>{{this.crud.observations.name}}
              </div>
            </b-col>
            <b-col lg="6">
              <div v-if="crud.observations.customer && crud.observations.customer.id" class="text-lg-right">
                <b-avatar :src="crud.observations.customer.image" v-if="crud.observations.customer.image"></b-avatar>
                <b-avatar v-else :text="avatarFromName(crud.observations.customer.name).text" :style="avatarFromName(crud.observations.customer.name).style"></b-avatar>
                <span class="ml-1 font-weight-bold">{{crud.observations.customer.name}}</span>
                <AppIcon name="cancel" v-if="!crud.observations.customer.active" class="ml-1 text-danger" v-b-tooltip.hover title="Cliente inactivo" />
              </div>
            </b-col>
          </b-row>
        </div>
        <b-form-group label="Observaciones" class="display-services-customers__observations-editor">
          <vue-editor class="display-observations-ql-editor" v-model="crud.observations.observations"></vue-editor>
        </b-form-group>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.observations.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveObservations()">Guardar</b-button>          
        </div>
      </b-modal>

      <!-- CRUD SERVICES -->
      <b-modal v-model="modal.service.active"              
              size="md">
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="swap_horiz" /></span><h5 class="app-modal-header__title">{{ modal.service.title }}</h5></div></template>

        <b-row>
          <b-col lg="6">            
            <div v-if="crud.service.service">
              <b>{{this.crud.service.service.name}}</b>
              <br>
              {{this.crud.service.name}}
            </div>
          </b-col>          
          <b-col lg="6">            
            <div v-if="crud.service.customer">
              <div v-if="crud.service.customer.id">             
                <b-avatar :src="crud.service.customer.image"
                          v-if="crud.service.customer.image">
                </b-avatar>
                <b-avatar v-else 
                          icon="building"                                            
                          variant="dark">
                </b-avatar>     
                &nbsp;<b>{{crud.service.customer.name}}</b>      
                <b-icon icon="circle-fill" v-if="!crud.service.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
              </div>
            </div>
          </b-col>

          <b-col lg="12">
            <hr>
          </b-col>      
          <b-col lg="12">
            <FindObject render="search"
                        type="services" 
                        @select-object="loadServices($event)" 
                        :valueID="crud.service.services_id"
                        :where="conditionServicesActive"/>             
          </b-col>   

          <b-col lg="12">
            <FindObject render="search"
                        type="priceList" 
                        @select-object="loadPriceList($event)" 
                        :valueID="crud.service.price_list_id"/>             
          </b-col>   

          <b-col lg="12">
            <b-form-group label="Fecha Renovación">                
              <b-form-datepicker size="sm" v-model="crud.service.date_renewal" placeholder="Fecha Renovación" local="es"></b-form-datepicker>                      
            </b-form-group>            
          </b-col>      
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.service.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveChangeService()">Cambiar</b-button>          
        </div>
      </b-modal>     

      <!-- PRECIOS -->
      <b-modal v-model="modal.price.active"
              >
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="payments" /></span><h5 class="app-modal-header__title">{{ modal.price.title }}</h5></div></template>

        <b-row>
          <b-col lg="12">            
            <div v-if="crud.price.customer">
              <div v-if="crud.price.customer.id">             
                <b-avatar :src="crud.price.customer.image"
                          v-if="crud.price.customer.image">
                </b-avatar>
                <b-avatar v-else 
                          icon="building"                                            
                          variant="dark">
                </b-avatar>     
                &nbsp;<b>{{crud.price.customer.name}}</b>      
                <b-icon icon="circle-fill" v-if="!crud.price.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                           
              </div>
            </div>
          </b-col>
          <b-col lg="12">            
            <div v-if="crud.price.service">
              <b>{{this.crud.price.service.name}}</b>
              <br>
              {{this.crud.price.name}}
            </div>
          </b-col>                    
        </b-row>
        <b-row class="mt-3">
          <b-col lg="12">
            <b-table class="mt-2 mb-0"
              responsive
              head-variant="dark"
              :hover="true"
              :small="true"
              :fixed="false"                              
              :items="tablePrice.items"
              :fields="tablePrice.fields"
              v-if="tablePrice.items.length">  

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 
              
              <template v-slot:cell(list)="data">                
                <div v-if="data.item.list">
                  {{data.item.list.name}}
                  <span v-if="data.item.list.public" class="crud-services-list-prices-public">
                    (Pública)
                  </span>
                </div>
              </template>                                        

              <template v-slot:cell(asignado)="data">                                
                <b-badge variant="secondary" 
                          v-if="data.item.price_list_id == crud.price.itemDetail.price_list_id">
                  Asignado
                </b-badge>                
              </template>        
              
              <template v-slot:cell(price)="data">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.list.currency.code}).format(data.item.amount_total)}}                
              </template>

            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>   
          </b-col>          
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.price.active=false">Cancelar</b-button>
        </div>
      </b-modal>       

      <!-- NOTIFICACIONES -->
      <b-modal v-model="modal.notification.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close         
              size="xl"
              :key="modal.notification._id"
              :id="modal.notification._id">                  
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="mail" /></span><h5 class="app-modal-header__title">{{ modal.notification.title }}</h5></div></template>

        <div v-if="modal.notification.all" class="display-services-customers__notification-selection">
          <AppIcon name="check2-square" class="mr-1" /> Se guardará esta notificación en {{ Array.isArray(modal.notification.id) ? modal.notification.id.length : 0 }} servicio{{ Array.isArray(modal.notification.id) && modal.notification.id.length == 1 ? '' : 's' }} seleccionado{{ Array.isArray(modal.notification.id) && modal.notification.id.length == 1 ? '' : 's' }}.
        </div>

        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-message variant="secondary" class="text-left">
                <b>MENSAJE DE NOTIFICACIÓN</b>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-message" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-form-group label="Fecha Notificación" description="Fecha en la que se envió la notificación">
                  <b-form-datepicker size="sm" v-model="modal.notification.date" placeholder="Fecha Notificación" local="es"></b-form-datepicker>                      
                </b-form-group>   
                <b-form-group description="Al dejar vacío el campo, se eliminará la notificación">
                  <vue-editor class="display-observations-ql-editor" v-model="modal.notification.message"></vue-editor>              
                </b-form-group>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1" v-if="modal.notification.customer">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-contact variant="secondary" class="text-left">
                <b>CONTACTOS DEL CLIENTE</b>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-contact" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-col lg="12">
                  <Contacts :customers="modal.notification.customer" :customersID="modal.notification.customer.id" :responsive="true"></Contacts>
                </b-col>                
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <div slot="modal-footer">
          <b-button variant="warning" class="mr-1" @click="modal.notification.active=false">Salir</b-button>    
          <b-button variant="dark" @click="saveNotification()" v-if="!modal.notification.all">Guardar</b-button>                
          <b-button variant="dark" @click="saveNotificationAll()" v-if="modal.notification.all">Guardar</b-button>                
        </div>
      </b-modal>      
  </div>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Param from '@/config/parameters'
  import moment from 'moment'
  import Storage from '@/handler/storageLocal'
  import DynamicSummary from '@/components/inc/reporting/DynamicSummary'
  import { VueEditor } from "vue2-editor";
  import FindObject from '@/components/inc/find/findObject'
  import Function from '@/handler/funciones'  
  import Contacts from '@/components/modules/users/_access/customer/staff/contacts/crud'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: { 
      DynamicSummary,
      VueEditor,
      FindObject,
      Contacts,
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.SERVICIOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'displayServicesCustomers',
          elements: {}
        }, 
        table : {
          items: [],
          fields: [
            {key: 'customers', label: 'Cliente', class:"align-middle", width:"150px"},                        
            {key: 'renewal', label: '', class:"align-middle", width:"25px"},                    
            {key: 'services', label: 'Servicio', class:"align-middle", width:"150px"},            
            {key: 'observations', label: '', class:"align-middle", width:"20px"},                        
            {key: 'date_init', label: 'Inicio', class:"align-middle text-center", width:"100px"},            
            {key: 'date_end', label: 'Fin', class:"align-middle text-center", width:"10px"},            
            {key: 'list', label: 'Lista', class:"align-middle text-center", width:"75px"},
            {key: 'quantity', label: 'Cantidad', class:"align-middle text-center", width:"75px"},            
            {key: 'price', label: 'Importe', class:"align-middle text-right", width:"100px"},     
            {key: 'total', label: 'Total', class:"align-middle text-right", width:"100px"},     
            {key: 'total_renewal', label: 'Renovación', class:"align-middle text-right", width:"100px"},     
            {key: 'full_sale', label: '', class:"align-middle text-center", width:"20px"},                         
            {key: 'date_renewal', label: '', class:"align-middle text-center", width:"140px"},
            {key: 'f_action', label:'', class:"align-middle", width:"20px"},
          ],
          currentPage: 1,
          perPage: 50,
          total: 0,
          isBusy: false,          
        },         
        tableActivity: {
          items: [],
          fields: [
            {key: 'services', label: 'Servicio', class:"align-middle", width:"150px"},            
            {key: 'date_end', label: 'Renovación', class:"align-middle text-left", width:"100px"},                        
            {key: 'date_init', label: 'Inicio', class:"align-middle text-left", width:"100px"},                        
            {key: 'price', label: 'Total', class:"align-middle text-right", width:"100px"},                 
            {key: 'sale_id', label: '', class:"align-middle text-center", width:"50px"},                 
            {key: 'f_action', label:'', class:"align-middle", width:"50px"},
          ],
        }, 
        tablePrice: {
          items: [],
          fields: [
            {key: 'list', label: 'Lista', class:"align-middle", width:"250px"},
            {key: 'price', label: 'Precio', class:"align-middle", width:"100px"},
            {key: 'asignado', label: '', class:"align-middle text-right", width:"100px"},
          ],
        },
        crud: {        
          renewal: {
            id: 0,
            date_renewal: '',
            date_next_renewal: '',
            name: '',
            customer: null,
            service: null,
            period: '',
            currency: '',
            price: 0,
          },
          cancel: {
            id: 0,
            reasons_canceled: '',
            date_end: ''
          },
          observations: {
            id: 0,
            name: '',
            service: null,
            customer: null,
            observations: '',
          },
          service: {
            id: 0,
            name: '',
            service: null,
            services: null,
            services_id: 0,
            customer: null,            
            date_renewal: '',
            price_list_id: 0,
            price_list : null,
          },
          price: {
            id: 0,            
            name: '',
            service: null,
            customer: null,    
            itemDetail: null                    
          }
        },            
        modal: {
          renewal: {
            active: false,
            title: ''
          },
          activity: {
            active: false,
            title: ''
          },
          cancel: {
            active: false,
            title: ''
          },      
          observations: {
            active: false,
            title: ''            
          },
          service: {
            active: false,
            title: ''            
          },
          price: {
            active: false,
            title: ''
          },
          notification: {
            active: false,
            title: '',
            id: 0,
            date: null,
            message: '',
            customer: null,
            all: false,
          },          
        },  
        arr: {
          servicesCustomersDetails: [],
          servicesCustomersActivitys: {
            name: '',
            customer: null,
            service: null,
            canceled: false,
          },
          filter : {
            services: [],
            customers: [],
            status: [
              {code:false, label: 'Activo'},
              {code:true, label: 'Finalizado'},                
            ],
          },
        },
        filter: {
          services: [],
          customers: [],
          status: [
            {code:false, label: 'Activo'}
          ],
        },
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
        detailDrawer: false,
        itemSelected: null,
        selectedServiceItems: [],
        history: {
          active: false,
          defaultGroups: ['category_service'],
          dimensions: [
            { key: 'category_service', label: 'Categoría' },
            { key: 'service', label: 'Servicio' },
            { key: 'customer', label: 'Cliente' },
            { key: 'currency', label: 'Moneda' },
            { key: 'period', label: 'Período' },
          ],
        },     
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {     
      this.filtersOpen = Storage.getValue('filters_open_display_services_customers') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()
      this.filterLoad() 
      this.filterServicesCustomersDetails()      

      this._start = true
    }, 
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 
            
      this.filterLoad() 
      this.filterServicesCustomersDetails()      
    },         
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    watch: {
      filtersOpen(value) {
        Storage.setValue('filters_open_display_services_customers', value ? 'true' : 'false')
      }
    },
    computed: {
      moduleSalesActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.VENTAS) {                             
            status = true                       
          }
        })        
        return status
      },
      hasSelectedServiceItems() {
        return this.selectedServiceItems.length > 0
      },
      selectedServiceCustomerId() {
        if (!this.hasSelectedServiceItems) return null
        var item = this.selectedServiceItems[0]
        return item && item.service_customer ? item.service_customer.customer_id : null
      },
      selectedServiceCustomerName() {
        if (!this.hasSelectedServiceItems) return ''
        var item = this.selectedServiceItems[0]
        return item && item.service_customer && item.service_customer.customer ? item.service_customer.customer.name : 'el cliente seleccionado'
      },
      eligibleServiceItems() {
        return this.table.items.filter(item => this.isServiceSelectionEligible(item))
      },
      allEligibleServiceItemsSelected() {
        return this.eligibleServiceItems.length > 0 && this.eligibleServiceItems.every(item => this.isServiceItemSelected(item))
      },
      detailCustomer() {
        return this.itemSelected && this.itemSelected.service_customer
          ? this.itemSelected.service_customer.customer
          : null
      },
      visibleServiceDetails() {
        return this.table.items
      },
      currentServiceDetailIndex() {
        if (!this.itemSelected) return -1
        return this.visibleServiceDetails.findIndex(item => item.id == this.itemSelected.id)
      },
      canGoPrevServiceDetail() {
        return this.currentServiceDetailIndex > 0
      },
      canGoNextServiceDetail() {
        return this.currentServiceDetailIndex >= 0 && this.currentServiceDetailIndex < this.visibleServiceDetails.length - 1
      },

      conditionServicesActive() {
        return [
          {field: 'active', condition: true},
          {field: 'show_only_erp', condition: false}
        ];
      },
            
      getTotal() {
        //obtengo las diferentes monedas
        var currency = []
        this.arr.servicesCustomersDetails.forEach(element => {
          var code = this.getRenewalCurrency(element)
          if(!currency.includes(code)) {
            currency[code] = 0
          }
        })
        
        // sumo totales por monedas
        this.arr.servicesCustomersDetails.forEach(element => {
          var code = this.getRenewalCurrency(element)
          currency[code] = currency[code] + this.getTotalService(element)
        });   
        
        //armo html para mostrar total                
        var htmlResult = ''
        if(currency) {          
          for(let prop of Object.keys(currency)) {
            htmlResult = htmlResult + Intl.NumberFormat('es-AR',{style:'currency',currency:prop}).format(currency[prop]) + '<br>'
          }          
        }
        return htmlResult        
      },     

      getTotalRenewal() {
        //obtengo las diferentes monedas
        var currency = []
        this.arr.servicesCustomersDetails.forEach(element => {
          var code = this.getRenewalCurrency(element)
          if(!currency.includes(code)) {
            currency[code] = 0
          }                    
        })
        
        // sumo totales por monedas
        this.arr.servicesCustomersDetails.forEach(element => {
          var code = this.getRenewalCurrency(element)
          currency[code] = currency[code] + this.getTotalRenewalService(element)
        });   
        
        //armo html para mostrar total                
        var htmlResult = ''
        if(currency) {          
          for(let prop of Object.keys(currency)) {
            htmlResult = htmlResult + Intl.NumberFormat('es-AR',{style:'currency',currency:prop}).format(currency[prop]) + '<br>'
          }          
        }
        return htmlResult             
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
        this.loadFieldTable()
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Function.avatarFromName(name)
      },
      openDetail(item, index, event) {
        if(event && event.target && event.target.closest('button, a, input, select, textarea, .dropdown')) return
        this.itemSelected = item
        this.detailDrawer = true
      },
      hideDetail() {
        this.detailDrawer = false
        this.itemSelected = null
      },
      goPrevServiceDetail() {
        if (!this.canGoPrevServiceDetail) return
        var item = this.visibleServiceDetails[this.currentServiceDetailIndex - 1]
        if (item) this.openDetail(item)
      },
      goNextServiceDetail() {
        if (!this.canGoNextServiceDetail) return
        var item = this.visibleServiceDetails[this.currentServiceDetailIndex + 1]
        if (item) this.openDetail(item)
      },
      formatServiceDate(date) {
        return date ? moment(date).format('DD/MM/YYYY') : '—'
      },
      formatServiceAmount(amount, currency) {
        return Intl.NumberFormat('es-AR', { style: 'currency', currency: currency || 'ARS' }).format(Number(amount) || 0)
      },
      getServiceModeDescription(item) {
        if (!item || !item.service) return '—'
        var service = item.service
        if (service.mode == 'days' || service.mode == 'months' || service.mode == 'years') {
          return (service.automatic_renewal ? 'Renovación automática' : 'Renovación manual') + ' · cada ' + service.renewal + ' ' + this.getModeName(service.mode).toLowerCase()
        }
        return this.getModeName(service.mode)
      },
      renewalStatusLabel(item) {
        var days = this.daysForRenewal(item)
        if (days < 1) return 'Vencido hace ' + this.daysVtoRenewal(item) + ' día/s'
        if (days == 1) return 'Vence hoy'
        return 'Faltan ' + days + ' día/s'
      },
      renewalStatusClass(item) {
        var days = this.daysForRenewal(item)
        if (days < 1) return 'display-services-customers-drawer__renewal--danger'
        if (days < 5) return 'display-services-customers-drawer__renewal--warning'
        return 'display-services-customers-drawer__renewal--success'
      },
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },
      isServiceItemSelected(item) {
        return this.selectedServiceItems.some(selected => selected.id == item.id)
      },
      isServiceSelectionEligible(item) {
        if (!this.hasSelectedServiceItems) return true
        return item && item.service_customer && item.service_customer.customer_id == this.selectedServiceCustomerId
      },
      toggleServiceSelection(item) {
        if (this.isServiceItemSelected(item)) {
          this.selectedServiceItems = this.selectedServiceItems.filter(selected => selected.id != item.id)
          return
        }
        if (!this.isServiceSelectionEligible(item)) return
        this.selectedServiceItems.push(item)
      },
      toggleSelectAllServiceItems() {
        if (this.allEligibleServiceItemsSelected) {
          var visibleIds = this.eligibleServiceItems.map(item => item.id)
          this.selectedServiceItems = this.selectedServiceItems.filter(item => !visibleIds.includes(item.id))
          return
        }
        this.eligibleServiceItems.forEach(item => {
          if (!this.isServiceItemSelected(item)) this.selectedServiceItems.push(item)
        })
      },
      clearServiceSelection() {
        this.selectedServiceItems = []
      },
      loadFieldTable() {
        this.table.fields = [
          {key: 'select_multi', label: '', class:'align-middle text-center', width:'3%'},
          {key: 'customers', label: 'Cliente', class:'align-middle', width:'15%'},
          {key: 'renewal', label: 'Modalidad', class:'align-middle', width:'11%'},
          {key: 'services', label: 'Servicio', class:'align-middle', width:'29%'},
          {key: 'date_init', label: 'Vigencia', class:'align-middle ' + this.alignClass('text-center'), width:'13%'},
          {key: 'price', label: 'Importes', class:'align-middle ' + this.alignClass('text-right'), width:'14%'},
          {key: 'date_renewal', label: 'Próxima renovación', class:'align-middle ' + this.alignClass('text-center'), width:'12%'},
          {key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:'align-middle', width:'3%'},
        ]
      },
      getRowCount (items) {
        return items.length
      },    
      load() {
        var result = serviceAPI.obtenerServicesCustomersDetails()

        result.then((response) => {
          var data = response.data
          this.table.items = data             
          
          this.arr.servicesCustomersDetails = data
          
          this.table.isBusy = false
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },
  
      filterLoad() {
        this.filterLoadCustomers()        
        this.filterLoadServices()

        this.restoreFilterStorage() 
      },
      filterLoadServices() {
        var result = serviceAPI.obtenerServices()        
        result.then((response) => {
          var data = response.data    

          this.arr.filter.services = []
          let arrActive = []
          let arrInactive = []                    
          data.forEach(element => {           
            if(!element.show_only_erp) {
              if(element.active) 
                arrActive.push({ code: element.id, label: element.category.name + " - " + element.name })            
              else
                arrInactive.push({ code: element.id, label: '[INACTIVO] - ' + element.category.name + " - " + element.name })            
            }
          });      
          this.arr.filter.services = arrActive.concat(arrInactive);        
        })   
      },      
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()        
        result.then((response) => {
          var data = response.data    
          
          let arrActive = []
          let arrInactive = []          
          data.forEach(element => {            
            if(element.active)
              arrActive.push({ code: element.id, label: element.name })            
            else 
              arrInactive.push({ code: element.id, label: '[INACTIVO] - ' + element.name })                                    
          });      
          this.arr.filter.customers = arrActive.concat(arrInactive);    
        })   
      },
      filterServicesCustomersDetails(page = 1, resetSelection = true){
        this.saveFilterStorage()
        if(resetSelection) this.clearServiceSelection()

        this.table.isBusy = true 
   
        var result = serviceAPI.filtrarServiceCustomersDetails(this.filter, page, this.table.perPage)
        result.then((response) => {     
          var data = response.data
          this.table.items = data.data || []
          this.arr.servicesCustomersDetails = this.table.items
          this.table.currentPage = data.current_page || page
          this.table.total = data.total || 0

          if(this.itemSelected) {
            var selected = this.table.items.find(item => item.id == this.itemSelected.id)
            if(selected) this.itemSelected = selected
            else this.hideDetail()
          }
          
          this.table.isBusy = false
        })
        .catch(error => {             
          this.table.isBusy = false          
          this.$awn.alert(Error.showError(error))
        });          
      },  

      setConfigTableDisplayServicesShow() {
        var arrTable = document.getElementsByClassName('table-displat-services-custom')
        var i = 0
        for(i=0; i<arrTable.length; i++) {          
          arrTable[i].style.minHeight = '400px'
        }        
      },
      setConfigTableDisplayServicesHide() {
        var arrTable = document.getElementsByClassName('table-displat-services-custom')
        var i = 0
        for(i=0; i<arrTable.length; i++) {
          arrTable[i].style.minHeight = 'auto'
        }        
      },        
      
      openRenewal(item) {
        this.crud.renewal.id = item.id
        this.crud.renewal.date_renewal = item.date_renewal       
        this.crud.renewal.customer = item.service_customer.customer
        this.crud.renewal.service = item.service
        this.crud.renewal.name = item.service_customer.name
        this.crud.renewal.period = item.service.renewal + ' ' + this.getModeName(item.service.mode)        
        this.crud.renewal.currency = item.price_list && item.price_list.currency ? item.price_list.currency.symbol : '$'
        this.crud.renewal.price = this.getRenewalUnitPrice(item)
        
        switch (item.service.mode) {
          case 'days':
            this.crud.renewal.date_next_renewal = moment(item.date_renewal).add(item.service.renewal, 'days').format('YYYY-MM-DD')
            break;
        
          case 'months':
            this.crud.renewal.date_next_renewal = moment(item.date_renewal).add(item.service.renewal, 'months').format('YYYY-MM-DD')
            break;

          case 'years':
            this.crud.renewal.date_next_renewal = moment(item.date_renewal).add(item.service.renewal, 'years').format('YYYY-MM-DD')
            break;            
        }
        
        this.modal.renewal._id = Math.random().toString(36).slice(2, 8)
        this.modal.renewal.active = true
        this.modal.renewal.title = "Renovar Servicio"
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])

        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      saveRenewal() {
        this.confirmDialog('¿Desea renovar el servicio?', {
          title: 'Renovar Servicio',
          icon: 'autorenew',
          okTitle: 'RENOVAR',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {                
            let loader = this.$loading.show();
            var result = serviceAPI.renewalServicesCustomersDetails(this.crud.renewal);

            result.then((response) => {      
              this.modal.renewal.active = false        
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Servicio Renovado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })          
      },
      
      openActivity(item) {                
        this.arr.servicesCustomersActivitys.customer = item.service_customer.customer
        this.arr.servicesCustomersActivitys.service = item.service
        this.arr.servicesCustomersActivitys.name = item.service_customer.name
        this.arr.servicesCustomersActivitys.canceled = item.canceled

        let loader = this.$loading.show()
        var result = serviceAPI.obtenerServicesCustomersDetailsActivity(item.id)
        result.then((response) => {
          this.tableActivity.items = [...response.data].reverse()
          this.modal.activity.active = true
          this.modal.activity.title = "Actividad del servicio"
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      removeActivity(item) {        
        var service = 'servicio ' + (item.service ? item.service.name : '');
        var customer = 'cliente ' + (item.customer ? item.customer.name : '')
        var period = 'periodo ' + moment(item.date_init).format('DD/MM/YYYY') + ' - ' + moment(item.date_end).format('DD/MM/YYYY')

        this.confirmDialog('¿Desea cancelar el ' + period + ' correspondiente al ' + service + ' asignado al ' + customer + '?', {
          title: 'Cancelar Actividad',
          icon: 'cancel',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();            

            var result = serviceAPI.eliminarServicesCustomersActivity(item.id);

            result.then((response) => {      
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Registro eliminado");
              this.modal.activity.active = false
            })
            .catch(error => {              
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          } 
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error));
        })
      },

      openObservations(item) {
        this.crud.observations.id = item.id
        this.crud.observations.observations = item.observations
        this.crud.observations.name = item.service_customer.name
        this.crud.observations.service = item.service
        this.crud.observations.customer = item.service_customer.customer

        this.modal.observations._id = Math.random().toString(36).slice(2, 8)
        this.modal.observations.active = true
        this.modal.observations.title = "Observaciones del Servicio"
      },
      saveObservations() {
        this.confirmDialog('¿Guardar Observaciones?', {
          title: 'Observaciones',
          icon: 'save',
          okTitle: 'GUARDAR',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {                
            let loader = this.$loading.show();
            
            var result = serviceAPI.editarObservacionesServicesCustomersDetails(this.crud.observations);

            result.then((response) => {                    
              this.modal.observations.active = false        
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Observaciones Guardada");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })            
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        }) 
      },
      previewPopoverObservations(item) {
        let style = '<style>p, ul {margin-bottom: 5px !important;}</style>'
        let observations = item.observations

        return style + observations
      },      

      openChangeService(item) {
        this.crud.service.id = item.id        
        this.crud.service.services = item.service
        this.crud.service.services_id = item.service.id
        this.crud.service.date_renewal = item.date_renewal

        this.crud.service.service = item.service
        this.crud.service.name = item.service_customer.name        
        this.crud.service.customer = item.service_customer.customer

        if(item.price_list) {
          this.crud.service.price_list = item.price_list
          this.crud.service.price_list_id = item.price_list.id
        } else {
          this.crud.service.price_list = null
          this.crud.service.price_list_id = 0
        }

        this.modal.service.active = true
        this.modal.service.title = "Cambio de Servicio"
      },      
      saveChangeService() {
        this.confirmDialog('¿Cambiar Servicio?', {
          title: 'Cambiar Servicio',
          icon: 'swap_horiz',
          okTitle: 'CAMBIAR',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {                
            let loader = this.$loading.show();
            
            var result = serviceAPI.cambiarServicesServicesCustomersDetails(this.crud.service);

            result.then((response) => {                    
              this.modal.service.active = false        
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Servicio cambiado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })                        
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        }) 
      },
      loadServices(object) {
        if(object){
          this.crud.service.services = object
          this.crud.service.services_id = object.id                    
        } else {
          this.crud.service.services = null
          this.crud.service.services_id = 0                              
        }
      },
      loadPriceList(object) {
        if(object){
          this.crud.service.price_list = object
          this.crud.service.price_list_id = object.id                    
        } else {
          this.crud.service.price_list = null
          this.crud.service.price_list_id = 0                              
        }
      },            

      daysForRenewal(item) {        
        var date1 = moment();
        var date2 = moment(item.date_renewal);

        return date2.diff(date1, 'days') + 1;
      },
      daysVtoRenewal(item) {        
        var date1 = moment(item.date_renewal);
        var date2 = moment();

        return date2.diff(date1, 'days') + 1;
      },        
      getTotalService(item) {
        var price = parseFloat(item && item.price)
        var quantity = parseFloat(item && item.quantity)
        price = isNaN(price) ? 0 : price
        quantity = isNaN(quantity) ? 0 : quantity

        if(quantity) {
          return quantity * price
        } else {
          return price
        }
      },
      getTotalRenewalService(item) {        
        var price = this.getRenewalUnitPrice(item)
        var quantity = parseFloat(item && item.quantity)
        quantity = isNaN(quantity) ? 0 : quantity

        if(quantity) {
          return quantity * price
        } else {
          return price
        }
      },
      getRenewalUnitPrice(item) {
        if(!item || !item.service || !Array.isArray(item.service.prices)) {
          return 0
        }

        var price = item.service.prices.find(element => Number(element.price_list_id) === Number(item.price_list_id))
        return price ? (parseFloat(price.amount_total) || 0) : 0
      },
      getRenewalCurrency(item) {
        if(item && item.price_list && item.price_list.currency && item.price_list.currency.code) {
          return item.price_list.currency.code
        }
        return 'ARS'
      },

      showChangeService(item) {
        return !item.canceled
      },
      showInvoiceService(item) {
        return !item.canceled
      },
      showRenewal(item) {
        return (item.service.mode=='days' || 
                item.service.mode=='months' || 
                item.service.mode=='years') && 
                !item.service.automatic_renewal &&
                !item.canceled        
      },
      showCanceled(item) {        
        if( !item.canceled && 
            (item.service.mode!='units' && item.service.mode!='hours') ) {
          return true
        } else {
          return false
        }
      },

      openPricesServices(item) {        
        this.crud.price.id = item.id
        this.crud.price.observations = item.observations
        this.crud.price.name = item.service_customer.name
        this.crud.price.service = item.service
        this.crud.price.customer = item.service_customer.customer
        this.crud.price.itemDetail = item
                
        this.tablePrice.items = this.orderPriceListByUtility(item.service.prices)        
        this.tablePrice.items.forEach(element => {                      
          if(item.price_list_id == element.price_list_id) {
            element._rowVariant = 'info'
          }            
        });
        
        this.modal.price.active = true
        this.modal.price.title = "Precios"
      },
      orderPriceListByUtility(arrData) {
        let arrSort = arrData.map(item => {          
          return {
            ...item,
            utility: parseFloat(item.list.utility),
            currency_id: item.list.currency_id
          };
        });

        return Function.sortArrayIntegerMultiField(arrSort, ['currency_id','utility'], 1)
      },

      openCancel(item) {
        this.crud.cancel.id = item.id
        this.crud.cancel.date_end = moment().format('YYYY-MM-DD')
        this.crud.cancel.reasons_canceled = ''
        
        this.modal.cancel.active = true
        this.modal.cancel.title = "Cancelar Servicio"
      },
      saveCancel() {
        this.confirmDialog('¿Desea cancelar el servicio?', {
          title: 'Cancelar Servicio',
          icon: 'cancel',
          danger: true,
          okTitle: 'ACEPTAR',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {      
            let loader = this.$loading.show();
            var result = serviceAPI.cancelarServicesCustomersDetails(this.crud.cancel);

            result.then((response) => {      
              this.modal.cancel.active = false        
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Servicio Cancelado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })          
      },
      restoreServoceCancel(item) {
        this.confirmDialog('¿Desea restaurar el servicio?', {
          title: 'Restaurar Servicio',
          icon: 'restore',
          okTitle: 'RESTAURAR',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {      
            let loader = this.$loading.show();            
            
            this.crud.cancel.id = item.id            
            var result = serviceAPI.restaurarServicesCustomersDetails(this.crud.cancel);

            result.then((response) => {      
              this.modal.cancel.active = false        
              loader.hide()
              this.filterServicesCustomersDetails()
              this.$awn.success("Servicio Restaurado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })          
      },   

      getModeName(mode) {
        let nameMode = ''

        switch (mode) {
          case 'units':
            nameMode = 'UNIDAD/ES'
            break;
          
          case 'hours':
            nameMode = 'HORA/S'
            break;

          case 'days':
            nameMode = 'DÍA/S'
            break;

          case 'months':
            nameMode = 'MES/ES'
            break;

          case 'years':
            nameMode = 'AÑO/S'
            break;            
        }

        return nameMode
      },

      // PROCESS ADMINISTRATIVE      
      generateInvoice(item) {
        this.$router.push({ 
          name: 'SalesStaffSalesGenerateByServiceCustomer', 
          params: {
            serviceCustomerID: item.id
          },
          query: {            
            customers_id: item.service_customer.customer_id,
            customers: JSON.stringify(item.service_customer.customer),                        
            detail: JSON.stringify([
              {
                quantity: 1, 
                service: item.service,
                services: item.service,
                currency: item.price_list.currency.code,
                price: item.price,                
                description: item.name,
                price_list: item.price_list,                
              }
            ])
          } 
        })
      },
      generateInvoiceSelected() {
        let serviceCustomerID = []
        let customer = null
        let query = []
        if(this.selectedServiceItems.length > 0) {
          customer = this.selectedServiceItems[0].service_customer.customer

          this.selectedServiceItems.forEach(item => {
            serviceCustomerID.push(item.id)

            query.push(
              {
                quantity: 1, 
                service: item.service,
                services: item.service,
                currency: item.price_list.currency.code,
                price: item.price,                
                description: item.name,
                price_list: item.price_list,                
              }
            )
          });
        }

        if(!customer) {
          this.$awn.alert('Seleccioná al menos un servicio para facturar')
          return
        }

        this.$router.push({ 
          name: 'SalesStaffSalesGenerateByServiceCustomer', 
          params: {
            serviceCustomerID: serviceCustomerID.join(',')
          },
          query: {            
            customers_id: customer.id,
            customers: JSON.stringify(customer),                        
            detail: JSON.stringify(query)
          } 
        })
      },

      //NOTIFICATIONS
      previewPopoverNotification(item) {
        let style = '<style>p, ul {margin-bottom: 0px !important;}</style>'        
        let message = item.message_notification

        let date1 = moment(item.date_notification);
        let date2 = moment();
        let diffDays = date2.diff(date1, 'days');
        let date = '' 
        
        if(diffDays == 0) {
          date = `<p><u>NOTIFICACIÓN</u>: Hoy</p>`
        } else if(diffDays == 1) {
            date = `<p><u>NOTIFICACIÓN</u>: Hace ${diffDays} día</p>`          
        } else {
          date = `<p><u>NOTIFICACIÓN</u>: Hace ${diffDays} días</p>`
        }        

        return style + date + '<hr>' + message
      },      
      generateTextNotificationEmail(item) {
        let text_1 = '<p>Hola <b>' + item.service_customer.customer.name + '</b>, espero que estés bien!</p><br>'                  
        let text_2 = '<p>En unos días se vencen los siguientes <b>servicios anuales</b> vinculados al dominio: <b>' + item.service_customer.name + '</b></p><br>'                  
        let text_3 = '<ul><li>' + item.service.display_sales_detail + '</li></ul><br>'                  
        let text_4 = '<p>El vencimiento es el próximo <b>' + moment(item.date_renewal).format('DD') + ' de ' + moment(item.date_renewal).format('MMMM') + '</b></p><br>'
        let text_5 = '<p>Costo renovación anual: <b>' +  Intl.NumberFormat('es-AR',{style:'currency',currency:item.price_list.currency.code}).format(this.getTotalRenewalService(item)) + '</b></p><br>'
        let text_6 = '<p>Confirmás renovación?</p><br>'
        let text_7 = '<p>Saludos</p>'

        this.modal.notification.id = item.id
        this.modal.notification.date = moment().format('YYYY-MM-DD')
        this.modal.notification.customer = item.service_customer.customer
        this.modal.notification.message = text_1 + text_2 + text_3 + text_4 + text_5 + text_6 + text_7
        this.modal.notification._id = Math.random().toString(36).slice(2, 8)
        this.modal.notification.title = 'Notificación por Email - Renovación de Servicio'
        this.modal.notification.active = true     
        this.modal.notification.all = false   
      },
      generateTextNotificationEmailSelected() {
        if(this.selectedServiceItems.length > 0) {
          let item = this.selectedServiceItems[0]
          let arrItem = this.selectedServiceItems

          let text_1 = '<p>Hola <b>' + item.service_customer.customer.name + '</b>, espero que estés bien!</p><br>'                  
          let text_2 = '<p>En unos días se vencen los siguientes <b>servicios anuales</b> vinculados al dominio: <b>' + item.service_customer.name + '</b></p><br>'                  

          let text_3 = '<ul>'
          arrItem.forEach(element => {
            text_3 = text_3 + '<li>' + element.service.display_sales_detail + '</li>'    
          });
          text_3 = text_3 + '</ul><br>'

          const dateMin = new Date(Math.min(...arrItem.map(element => new Date(element.date_renewal))));          
          let text_4 = '<p>El vencimiento es el próximo <b>' + moment(dateMin).format('DD') + ' de ' + moment(dateMin).format('MMMM') + '</b></p><br>'        

          const sumTotal = arrItem.reduce((acum, item) => acum + this.getTotalRenewalService(item), 0);
          let text_5 = '<p>Costo renovación anual: <b>' +  Intl.NumberFormat('es-AR',{style:'currency',currency:item.price_list.currency.code}).format(sumTotal) + '</b></p><br>'

          let text_6 = '<p>Confirmás renovación?</p><br>'
          let text_7 = '<p>Saludos</p>'

          this.modal.notification.id = arrItem.map(obj => obj.id);
          this.modal.notification.date = moment().format('YYYY-MM-DD')
          this.modal.notification.customer = item.service_customer.customer
          this.modal.notification.message = text_1 + text_2 + text_3 + text_4 + text_5 + text_6 + text_7
          this.modal.notification._id = Math.random().toString(36).slice(2, 8)
          this.modal.notification.title = 'Notificación por Email - Renovación de Servicio'
          this.modal.notification.active = true   
          this.modal.notification.all = true
        } else {
          this.$awn.alert("No se encontraron servicios para notificar");
        }     
      },
      generateTextNotificationWhatsapp(item) {
        let text_1 = 'Hola *' + item.service_customer.customer.name + '*, espero que estés bien!\n\n'                  
        let text_2 = 'En unos días se vencen los siguientes *servicios anuales* vinculados al dominio: *' + item.service_customer.name + '*\n\n'                  
        let text_3 = '- ' + item.service.display_sales_detail + '\n\n'                  
        let text_4 = 'El vencimiento es el próximo *' + moment(item.date_renewal).format('DD') + ' de ' + moment(item.date_renewal).format('MMMM') + '*\n\n'
        let text_5 = 'Costo renovación anual: *' +  Intl.NumberFormat('es-AR',{style:'currency',currency:item.price_list.currency.code}).format(this.getTotalRenewalService(item)) + '*\n\n'
        let text_6 = 'Confirmás renovación?\n\n'
        let text_7 = 'Saludos'

        this.modal.notification.id = item.id
        this.modal.notification.date = moment().format('YYYY-MM-DD')
        this.modal.notification.customer = item.service_customer.customer
        this.modal.notification.message = text_1 + text_2 + text_3 + text_4 + text_5 + text_6 + text_7
        this.modal.notification._id = Math.random().toString(36).slice(2, 8)
        this.modal.notification.title = 'Notificación por WhatsApp - Renovación de Servicio'
        this.modal.notification.active = true
        this.modal.notification.all = false
      },
      generateTextNotificationWhatsappSelected() {
        if(this.selectedServiceItems.length > 0) {
          let item = this.selectedServiceItems[0]
          let arrItem = this.selectedServiceItems
        
          let text_1 = 'Hola *' + item.service_customer.customer.name + '*, espero que estés bien!\n\n'                  
          let text_2 = 'En unos días se vencen los siguientes *servicios anuales* vinculados al dominio: *' + item.service_customer.name + '*\n\n'                  
          
          let text_3 = ''
          arrItem.forEach(element => {
            text_3 = text_3  + '- ' + element.service.display_sales_detail + '\n'                  
          });
          text_3 = text_3 + '\n'

          const dateMin = new Date(Math.min(...arrItem.map(element => new Date(element.date_renewal))));    
          let text_4 = 'El vencimiento es el próximo *' + moment(dateMin).format('DD') + ' de ' + moment(dateMin).format('MMMM') + '*\n\n'

          const sumTotal = arrItem.reduce((acum, item) => acum + this.getTotalRenewalService(item), 0);
          let text_5 = 'Costo renovación anual: *' +  Intl.NumberFormat('es-AR',{style:'currency',currency:item.price_list.currency.code}).format(sumTotal) + '*\n\n'
          
          let text_6 = 'Confirmás renovación?\n\n'
          let text_7 = 'Saludos'

          this.modal.notification.id = arrItem.map(obj => obj.id);
          this.modal.notification.date = moment().format('YYYY-MM-DD')
          this.modal.notification.customer = item.service_customer.customer
          this.modal.notification.message = text_1 + text_2 + text_3 + text_4 + text_5 + text_6 + text_7
          this.modal.notification._id = Math.random().toString(36).slice(2, 8)
          this.modal.notification.title = 'Notificación por WhatsApp - Renovación de Servicio'
          this.modal.notification.active = true
          this.modal.notification.all = true
        } else {
          this.$awn.alert("No se encontraron servicios para notificar");
        }    
      },      
      saveNotification() {      
        let loader = this.$loading.show();            

        var result = serviceAPI.editarNotificacionesServicesCustomersDetails({
          id: this.modal.notification.id,
          date_notification: this.modal.notification.date,
          message_notification: this.modal.notification.message,
        });

        result.then((response) => {                    
          loader.hide()
          this.filterServicesCustomersDetails()
          this.$awn.success("Notificación Guardada");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },
      saveNotificationAll() {      
        let loader = this.$loading.show();            

        var result = serviceAPI.editarNotificacionesServicesCustomersDetailsLote({
          ids: this.modal.notification.id,
          date_notification: this.modal.notification.date,
          message_notification: this.modal.notification.message,
        });

        result.then((response) => {                                  
          loader.hide()
          this.filterServicesCustomersDetails()
          this.$awn.success("Notificaciónes Guardadas");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },      

      // HISTORIAL: el componente solicita el resumen agregado y paginado.
      // Nunca descarga todas las actividades al navegador.
      loadServicesCustomersActivitys() {
        this.history.active = true
      },
      loadHistoryReport(params) {
        return serviceAPI.resumenServicesCustomersActivity(params)
      },
      showHistoryError(error) {
        this.$awn.alert(Error.showError(error))
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_display_services_customers', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_display_services_customers')) {
          this.filter = JSON.parse(Storage.getValue('filter_display_services_customers'))
        }         
      },

      goProject(item) {
        this.$router.push({ name: 'ProjectStaffDetailHoursProjects', params: { projectID: item.project_id } })                  
      }
    }    
  }
</script>
<style scoped>
  .crud-services-customers-reasons-canceled {
    cursor: pointer;
  }
  .crud-services-vto-warning {
    background: #fff3cd;
    font-weight: bold;
    color: #8a5a00;
    border-radius: 4px;
    padding: 2px 5px;
  }
  .crud-services-vto-success {
    background: #e7f6ed;
    font-weight: bold;
    color: #18794e;
    border-radius: 4px;
    padding: 2px 5px;
  }  
  .crud-services-vto-danger {
    background: #fdebec;
    font-weight: bold;
    color: #b42318;
    border-radius: 4px;
    padding: 2px 5px;
  }      
  .display-service-customers-table-foot-legend {
    background: var(--gray-dark);
    color: #fff;
    font-weight: 600;
    text-align: right;
    padding-right: 10px;
    font-size: 16px;
    vertical-align: middle;
  }
  .display-service-customers-table-foot-total {
    background: var(--gray-dark);
    color: #fff;
    font-weight: 600;
    text-align: right;
    padding-right: 10px;
    font-size: 16px;
  }  
  .display-service-customers-table-foot-total-renewal {
    background: var(--gray-dark);
    color: #fff;
    font-weight: 600;
    text-align: right;
    padding-right: 10px;
    font-size: 16px;    
    font-style: italic;
  }
  .display-services-customer-legend {
    cursor: pointer;
  }
  .display-services-customer-form-renewal-period-legend {
    font-size: 14px;
  }
  .display-services-legend-renewal {
    cursor: pointer;
  }  
  .display-services-customers__renewal {
    display: flex;
    align-items: center;
    gap: .45rem;
    min-width: 0;
  }
  .display-services-customers__renewal .app-icon {
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
    padding: 6px;
    border-radius: 50%;
  }
  .display-services-customers__renewal--automatic .app-icon { background: #e7f6ed; color: #18794e; }
  .display-services-customers__renewal--manual .app-icon { background: #fff3e0; color: #a55a00; }
  .display-services-customers__renewal strong,
  .display-services-customers__renewal small,
  .display-services-customers__service span { display: block; }
  .display-services-customers__renewal strong { color: #283c54; font-size: .78rem; }
  .display-services-customers__renewal small { color: #718399; font-size: .68rem; line-height: 1.2; }
  .display-services-customers__service { min-width: 0; }
  .display-services-customers__service > strong { display: block; color: #172b44; line-height: 1.25; white-space: normal; overflow-wrap: anywhere; }
  .display-services-customers__service > span { color: #5d7088; font-size: .76rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .display-services-customers__service-icons { display: inline-flex; gap: .2rem; margin-top: .2rem; }
  .display-services-customers__service-icons .btn { color: #4d627b; padding: 0; line-height: 1; }
  .display-services-customers__service-icon { color: #4d627b; font-size: .95rem; }
  .display-services-customers__contract {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: .35rem 1rem;
    padding: .42rem .55rem;
    border: 1px solid #cddfec;
    border-radius: .35rem;
    background: transparent;
    white-space: normal;
  }
  .display-services-customers__contract span { display: inline-flex; flex-direction: column; min-width: 0; color: #263d57; font-size: .78rem; }
  .display-services-customers__contract-end { grid-column: 1; }
  .display-services-customers__contract-list { grid-column: 2; grid-row: 1 / span 2; align-self: center; }
  .display-services-customers__contract-quantity { grid-column: 1 / span 2; }
  .display-services-customers__contract--without-end .display-services-customers__contract-list { grid-row: 1; }
  .display-services-customers__contract small,
  .display-services-customers__amounts small { color: #718399; font-size: .63rem; line-height: 1.15; text-transform: uppercase; letter-spacing: .025em; }
  .display-services-customers__contract small { color: #4f7192; }
  .display-services-customers__amounts {
    display: flex;
    flex-direction: column;
    gap: .28rem;
    padding: .42rem .55rem;
    border: 1px solid #d9e4ef;
    border-radius: .35rem;
    background: rgba(255, 255, 255, .7);
  }
  .display-services-customers__amounts span { display: flex; justify-content: space-between; align-items: baseline; gap: .5rem; }
  .display-services-customers__amounts span + span { border-top: 1px solid #d9e4ef; padding-top: .28rem; }
  .display-services-customers__amounts small { padding: .12rem .25rem; border-radius: .2rem; background: #e8f1f8; color: #496b88; }
  .display-services-customers__amounts strong { color: #183b5a; font-size: .78rem; white-space: nowrap; }
  .display-services-customers__due { max-width: 100%; overflow: hidden; }
  .display-services-customers__due > div { display: inline-block; max-width: 100%; overflow-wrap: anywhere; line-height: 1.3; }
  .display-services-customers__due strong,
  .display-services-customers__due small { display: block; }
  .display-services-customers__due-ended {
    display: flex;
    align-items: center;
    gap: .4rem;
    max-width: 100%;
    padding: .35rem .45rem;
    border: 1px solid #f0c7cb;
    border-radius: .35rem;
    background: #fff4f4;
    color: #a72e38;
  }
  .display-services-customers__due-ended > .app-icon { color: #c43b46; }
  .display-services-customers__due-ended strong,
  .display-services-customers__due-ended small { display: block; line-height: 1.2; }
  .display-services-customers__due-ended strong { font-size: .76rem; text-transform: uppercase; }
  .display-services-customers__due-ended small { color: #86535a; font-size: .67rem; }
  .display-services-customers__due-ended-info { margin-left: auto; padding: 0; color: #9b5660; }
  .table-displat-services-custom tbody td:first-child { padding-left: .8rem !important; }
  .display-services-customers__modal-context {
    margin: 0 0 1rem;
    padding: .75rem;
    border: 1px solid #d8e3ee;
    border-radius: .4rem;
    background: #f8fbfe;
  }
  .display-services-customers__observations-editor .ql-toolbar,
  .display-services-customers__observations-editor .ql-container { background: transparent; }
  .display-services-customer-table-activity {
    min-height: 100px;
    overflow: auto;
    height: 400px;    
  }  
  .popover-observations {
    cursor: pointer;
  }
  .crud-services-list-prices-public {
    font-size: 10px;
    font-weight: 600;
    color: gray;
  }  
  .display-services-customers__totals {
    align-items: center;
    justify-content: flex-end;
    gap: 1.5rem;
    background: #f7fafc;
    border-top: 1px solid #cbd9e7;
  }
  .display-services-customers__totals-label {
    color: #52677f;
    font-weight: 700;
    text-transform: uppercase;
    font-size: .72rem;
    letter-spacing: .03em;
  }
  .display-services-customers__totals span:not(.display-services-customers__totals-label) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    color: #1d2f44;
  }
  .display-services-customers__totals small {
    color: #667b92;
    text-transform: uppercase;
    font-size: .65rem;
    letter-spacing: .03em;
  }
  .display-services-customers__totals strong {
    line-height: 1.25;
  }
  .display-services-customers__selection-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 42px;
    padding: 7px 12px;
    border-bottom: 1px solid var(--app-color-primary-200);
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
    font-size: var(--app-text-sm);
  }
  .display-services-customers__selection-bar > span { display: inline-flex; align-items: center; font-weight: var(--app-font-semibold); }
  .display-services-customers__selection-bar > div { display: flex; align-items: center; flex-wrap: wrap; }
  .display-services-customers__selection-bar .list-view-link { padding: 0; color: var(--app-color-primary-active); font-size: var(--app-text-sm); }
  .display-services-customers__selection-check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 29px;
    height: 29px;
    border: 1px solid var(--app-color-border-strong);
    border-radius: 7px;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text-secondary);
    cursor: pointer;
    line-height: 1;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease, transform .15s ease;
  }
  .display-services-customers__selection-check:hover {
    border-color: var(--app-color-primary-200);
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
    transform: scale(1.06);
  }
  .display-services-customers__selection-check--selected {
    border-color: var(--app-color-primary);
    background: var(--app-color-primary);
    color: var(--app-color-on-primary);
  }
  .display-services-customers__selection-check--selected:hover { background: var(--app-color-primary-hover); color: var(--app-color-on-primary); }
  .display-services-customers__notification-selection {
    margin: 0 0 12px;
    padding: 9px 10px;
    border: 1px solid var(--app-color-primary-200);
    border-radius: 8px;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
    font-size: var(--app-text-sm);
  }
  .display-services-customers-drawer__header {
    background: var(--app-color-primary-soft);
    border: 1px solid var(--app-color-info-border);
    border-radius: 10px;
    padding: 12px;
  }
  .display-services-customers-drawer__header .list-view-drawer__code { color: var(--app-color-primary-active); }
  .display-services-customers-drawer__avatar { flex: 0 0 42px; height: 42px !important; width: 42px !important; }
  .display-services-customers-drawer__section { margin-bottom: 14px; }
  .display-services-customers-drawer__service-card {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    background: var(--app-color-surface);
    border: 1px solid var(--app-color-border);
    border-radius: 9px;
    overflow: hidden;
  }
  .display-services-customers-drawer__service-card > div { display: flex; flex-direction: column; gap: 2px; min-height: 52px; padding: 8px; }
  .display-services-customers-drawer__service-card > div:nth-child(odd) { border-right: 1px solid var(--app-color-border); }
  .display-services-customers-drawer__service-card > div:nth-child(n + 3) { border-top: 1px solid var(--app-color-border); }
  .display-services-customers-drawer__service-card span { color: var(--app-color-text-secondary); font-size: 10px; text-transform: uppercase; }
  .display-services-customers-drawer__service-card strong { color: var(--app-color-text); font-size: var(--app-text-sm); line-height: 1.25; overflow-wrap: anywhere; }
  .display-services-customers-drawer__amount { color: var(--app-color-success) !important; }
  .display-services-customers-drawer__renewal-card {
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 9px 10px;
    border: 1px solid var(--app-color-success-border);
    border-radius: 9px;
    background: var(--app-color-success-soft);
  }
  .display-services-customers-drawer__renewal-card strong { color: var(--app-color-text); font-size: var(--app-text-sm); }
  .display-services-customers-drawer__renewal-card small { font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); }
  .display-services-customers-drawer__renewal-card--ended { background: var(--app-color-danger-soft); border-color: var(--app-color-danger-border); }
  .display-services-customers-drawer__renewal--success { color: var(--app-color-success); }
  .display-services-customers-drawer__renewal--warning { color: var(--app-color-warning-hover); }
  .display-services-customers-drawer__renewal--danger { color: var(--app-color-danger); }
  .display-services-customers-drawer__observations {
    padding: 9px 10px;
    border: 1px solid var(--app-color-info-border);
    border-radius: 9px;
    background: var(--app-color-info-soft);
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-sm);
    line-height: 1.45;
  }
  .display-services-customers-drawer__observations p { margin-bottom: 6px; }
  .display-services-customers-drawer__actions { display: grid; gap: 10px; margin-top: 18px; }
  .display-services-customers-drawer__action-group { padding-top: 10px; border-top: 1px solid var(--app-color-border); }
  .display-services-customers-drawer__action-group > span { display: block; margin-bottom: 6px; color: var(--app-color-text-secondary); font-size: 10px; font-weight: var(--app-font-semibold); letter-spacing: .04em; text-transform: uppercase; }
  .display-services-customers-drawer__action-group > div { display: flex; flex-direction: column; align-items: stretch; gap: 6px; }
  .display-services-customers-drawer__action-group .btn { width: 100%; text-align: left; }
  .display-services-customers-action-toggle {
    color: #314d6e !important;
    padding: .2rem .45rem !important;
  }
  @media (max-width: 767.98px) {
    .display-services-customers__service > span { white-space: normal; }
    .display-services-customers__totals {
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      gap: .75rem 1.25rem;
    }
    .display-services-customers__totals span:not(.display-services-customers__totals-label) {
      align-items: flex-start;
    }
    .display-services-customers-drawer__service-card { grid-template-columns: 1fr; }
    .display-services-customers-drawer__service-card > div { border-right: 0 !important; }
    .display-services-customers-drawer__service-card > div + div { border-top: 1px solid var(--app-color-border); }
    .display-services-customers__selection-bar { align-items: flex-start; flex-direction: column; }
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>
<style>
  .display-observations-ql-editor .ql-editor {
    min-height: 350px !important;
  }  
  .display-services-customers__observations-editor .ql-toolbar,
  .display-services-customers__observations-editor .ql-container {
    background: transparent !important;
  }
</style>
